














import {
  Vue,
  Component,
} from "@/shared/vuepack";

import HowItWorksSteps from "./HowItWorksSteps.vue";

@Component({
  components: {
    HowItWorksSteps
  }
})
export default class HowItWorks extends Vue {
  isOpen = true;
  mounted (): void {
    if (window.innerWidth < 768) {
      this.isOpen = false;
    }
  }
}
